
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(6 8)"}},[_c('path',{attrs:{"d":"M39.455 2.944c1.753-3.925 7.337-3.925 9.09 0l8.997 20.14A4.976 4.976 0 0061.565 26l21.974 2.314c4.284.451 6.009 5.75 2.81 8.627l-16.415 14.76a4.96 4.96 0 00-1.537 4.72l4.585 21.57c.894 4.204-3.623 7.478-7.354 5.331L46.486 72.306a4.986 4.986 0 00-4.972 0L22.373 83.322c-3.731 2.147-8.249-1.127-7.355-5.332l4.585-21.569a4.96 4.96 0 00-1.537-4.72L1.651 36.942c-3.2-2.877-1.474-8.176 2.81-8.627L26.435 26a4.976 4.976 0 004.023-2.917l8.997-20.139z"}}),_c('path',{attrs:{"stroke-width":"4","stroke-linecap":"round","d":"M16 2v16m-8-8h16"}}),_c('circle',{attrs:{"cx":"69","cy":"17","r":"4"}}),_c('circle',{attrs:{"cx":"83","cy":"69","r":"4"}}),_c('circle',{attrs:{"cx":"4","cy":"75","r":"4"}})])])
          )
        }
      }
    